import React from "react";
import ArrowLeft from "../../../assets/arrow_left.svg";
import { ClaimServices, ClaimStatuses, ClaimTypes } from "../../../types/travelClaims";
import { useGoBack } from "../../../hooks/useGoBack";
import { getClaimTypeName } from "../../../helpers/claims";
import { getClaimStatus } from "./Statuses";
import { User } from "../../../types/users";
import { getUserLastFirstName } from "../../../helpers/users";
import { Country } from "../../../types/geo";
import { HistoryDropdown } from "../History";
import { formatDates } from "../../../helpers/dates"
import { isSafari } from "../../../helpers/browsers"

interface BreadcrumbsProps {
    claimType: ClaimTypes
}

interface ClaimStatusProps {
    direction_name?: string
    name?: string
    started_at?: string
    finished_at?: string
    status: ClaimStatuses,
    service: ClaimServices
    country?: Country
}

interface ClaimHeaderProps {
    created_at: string
    pk: number
    author: User
}


export const ClaimBreadcrumbs = ({ claimType }: BreadcrumbsProps) => {
    const goBack = useGoBack();

    return <div className="inline-flex items-center gap-5 relative">
        <button
            onClick={() => goBack({ fallback: '/claims' })}
            className="relative w-12 h-12 bg-white rounded-lg overflow-hidden">
            <img alt="" src={ArrowLeft} className="!absolute !w-6 !h-6 !top-3 !left-3" />
        </button>
        <div
            className="relative w-full font-manager-acrom font-[number:var(--manager-acrom-font-weight)] text-black text-[length:var(--manager-acrom-font-size)] tracking-[var(--manager-acrom-letter-spacing)] leading-[var(--manager-acrom-line-height)] [font-style:var(--manager-acrom-font-style)]">
            {getClaimTypeName(claimType)}
        </div>
    </div>
}

export const EditHeader = () => {
    return (
        <div className="
            flex w-full
            items-start
            p-5 bg-white rounded-t-lg
            shadow-shadow-card
            ">
            <div
                className="inline-flex h-6 w-full mt-[-1.00px] text-[#949494] text-[length:var(--manager-acrom-ph1-16-medium-acrom-font-size)] leading-[var(--manager-acrom-ph1-16-medium-acrom-line-height)] font-manager-acrom-ph1-16-medium-acrom font-[number:var(--manager-acrom-ph1-16-medium-acrom-font-weight)] tracking-[var(--manager-acrom-ph1-16-medium-acrom-letter-spacing)] [font-style:var(--manager-acrom-ph1-16-medium-acrom-font-style)]">
                Редактирование
            </div>
        </div>
    );
}

export const ClaimHeader = ({ created_at, pk, author }: ClaimHeaderProps) => {
    return (
        <div
            className="z-10 w-full min-h-20 flex flex-row justify-between items-centerbg-white rounded-[8px_8px_0px_0px] p-5 shadow-shadow-card"
            style={{ overflow: isSafari() ? 'visible' : 'hidden' }}>
            <div className="w-4/6 inline-flex justify-start gap-0.5 flex-col items-start">
                <div
                    className="w-full text-black text-[length:var(--manager-acrom-h3-20-medium-acrom-font-size)] leading-[var(--manager-acrom-h3-20-medium-acrom-line-height)] relative font-manager-acrom-h3-20-medium-acrom font-[number:var(--manager-acrom-h3-20-medium-acrom-font-weight)] tracking-[var(--manager-acrom-h3-20-medium-acrom-letter-spacing)] [font-style:var(--manager-acrom-h3-20-medium-acrom-font-style)]">
                    {pk}
                </div>
                <div
                    className="w-full text-[#949494] text-[length:var(--manager-acrom-ph1-16-medium-acrom-font-size)] leading-[var(--manager-acrom-ph1-16-medium-acrom-line-height)] relative font-manager-acrom-ph1-16-medium-acrom font-[number:var(--manager-acrom-ph1-16-medium-acrom-font-weight)] tracking-[var(--manager-acrom-ph1-16-medium-acrom-letter-spacing)] [font-style:var(--manager-acrom-ph1-16-medium-acrom-font-style)]">
                    {getUserLastFirstName(author)} — {new Date(created_at).toLocaleDateString()}
                </div>
            </div>
            <div
                className="w-2/6 inline-flex min-w-44 items-center justify-center gap-2.5 px-5 py-2.5 bg-[#f2f2f2] rounded-lg">
                {/*<div className="w-full whitespace-break-spaces text-black text-[length:var(--manager-acrom-ph1-16-medium-acrom-font-size)] leading-[var(--manager-acrom-ph1-16-medium-acrom-line-height)] relative font-manager-acrom-ph1-16-medium-acrom font-[number:var(--manager-acrom-ph1-16-medium-acrom-font-weight)] tracking-[var(--manager-acrom-ph1-16-medium-acrom-letter-spacing)] [font-style:var(--manager-acrom-ph1-16-medium-acrom-font-style)]">*/}
                {/*    История заявки*/}
                {/*</div>*/}
                <HistoryDropdown />
            </div>
        </div>
    );
}

export const ClaimEditHeader = ({ created_at, pk, author }: ClaimHeaderProps) => {
    return (
        <div className="flex flex-col w-full p-5 items-start gap-5 relative flex-[0_0_auto]">
            <div className="flex w-full items-end gap-2.5 relative flex-[0_0_auto]">
                <div
                    className="w-1/2 mt-[-1.00px] text-black text-[length:var(--manager-acrom-h3-20-medium-acrom-font-size)] leading-[var(--manager-acrom-h3-20-medium-acrom-line-height)] relative font-manager-acrom-h3-20-medium-acrom font-[number:var(--manager-acrom-h3-20-medium-acrom-font-weight)] tracking-[var(--manager-acrom-h3-20-medium-acrom-letter-spacing)] [font-style:var(--manager-acrom-h3-20-medium-acrom-font-style)]">
                    Заявка №{pk}
                </div>
                <div
                    className="w-1/2 text-[#949494] text-[length:var(--manager-acrom-ph1-16-medium-acrom-font-size)] text-right leading-[var(--manager-acrom-ph1-16-medium-acrom-line-height)] relative font-manager-acrom-ph1-16-medium-acrom font-[number:var(--manager-acrom-ph1-16-medium-acrom-font-weight)] tracking-[var(--manager-acrom-ph1-16-medium-acrom-letter-spacing)] [font-style:var(--manager-acrom-ph1-16-medium-acrom-font-style)]">
                    {getUserLastFirstName(author)} — {new Date(created_at).toLocaleDateString()}
                </div>
            </div>
        </div>
    );
};

export const SimpleClaimStatus = ({ direction_name, status, started_at, finished_at, service }: ClaimStatusProps) => {
    return (
        <div className="inline-flex flex-col w-full items-start gap-2.5 p-5 relative flex-[0_0_auto] bg-white">
            {getClaimStatus(status)}
            <div className="inline-flex flex-col items-start gap-5 relative flex-[0_0_auto]">
                <div className="inline-flex flex-col items-start gap-2.5 relative flex-[0_0_auto]">
                    <div className="flex w-full gap-1 relative flex-[0_0_auto] flex-col items-start">
                        <div
                            className="
                            relative
                            w-full
                            font-manager-acrom-h4-24-medium-acrom
                            font-[number:var(--manager-acrom-h4-24-medium-acrom-font-weight)]
                            text-black
                            text-[length:var(--manager-acrom-h4-24-medium-acrom-font-size)]
                            tracking-[var(--manager-acrom-h4-24-medium-acrom-letter-spacing)]
                            leading-[var(--manager-acrom-h4-24-medium-acrom-line-height)]
                            [font-style:var(--manager-acrom-h4-24-medium-acrom-font-style)]
                            ">
                            {direction_name}
                        </div>
                        <div
                            className="relative w-full text-black font-manager-acrom-ph1-16-medium-acrom font-[number:var(--manager-acrom-ph1-16-medium-acrom-font-weight)] text-[length:var(--manager-acrom-ph1-16-medium-acrom-font-size)] tracking-[var(--manager-acrom-ph1-16-medium-acrom-letter-spacing)] leading-[var(--manager-acrom-ph1-16-medium-acrom-line-height)] [font-style:var(--manager-acrom-ph1-16-medium-acrom-font-style)]">
                            {formatDates(started_at, finished_at)}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export const ComplexClaimStatus = ({ name, status, service }: ClaimStatusProps) => {
    return (
        <div className="inline-flex flex-col items-start gap-2.5 p-5 relative flex-[0_0_auto] bg-white">
            {getClaimStatus(status)}
            <div className="flex flex-col w-full items-start gap-5 relative flex-[0_0_auto]">
                <div className="flex flex-col w-full items-start gap-1 relative flex-[0_0_auto]">
                    <div className="flex w-full gap-1 relative flex-col items-start">
                        <div
                            className="
                            w-full
                            text-black
                            text-[length:var(--manager-acrom-h4-24-medium-acrom-font-size)]
                            leading-[var(--manager-acrom-h4-24-medium-acrom-line-height)]
                            relative
                            font-manager-acrom-h4-24-medium-acrom
                            font-[number:var(--manager-acrom-h4-24-medium-acrom-font-weight)]
                            tracking-[var(--manager-acrom-h4-24-medium-acrom-letter-spacing)]
                            [font-style:var(--manager-acrom-h4-24-medium-acrom-font-style)]
                            ">
                            {name}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export const VisaStatus = ({ country, status, service }: ClaimStatusProps) => {
    return (
        <div className="inline-flex flex-col items-start gap-2.5 p-5 relative flex-[0_0_auto] bg-white">
            {getClaimStatus(status)}
            <div className="flex flex-col w-full items-start gap-1 relative flex-[0_0_auto]">
                <div
                    className="w-full text-black text-[length:var(--manager-acrom-h4-24-medium-acrom-font-size)] leading-[var(--manager-acrom-h4-24-medium-acrom-line-height)] relative font-manager-acrom-h4-24-medium-acrom font-[number:var(--manager-acrom-h4-24-medium-acrom-font-weight)] tracking-[var(--manager-acrom-h4-24-medium-acrom-letter-spacing)] [font-style:var(--manager-acrom-h4-24-medium-acrom-font-style)]">
                    {country && country.name}
                </div>
            </div>
        </div>
    );
}